import Container from "components/Container";
import NewTable from "components/NewTable";
import PageHeader from "components/Page/PageHeader";
import useUnidadesUnificadas from "core/features/unidade-unificada/hooks/useUnidadesUnificadas";
import useUnidadesUnificadasColumns from "core/features/unidade-unificada/hooks/useUnidadesUnificadasColumns";
import { UnidadeUnificadaResponse } from "core/features/unidade-unificada/typings/index";
import { useBreadcrumb } from "features/breadcrumbs";
import { showSuccess, showConfirm } from "infra/helpers/alerta";
import useFiltro from "infra/helpers/useFiltro";
import { useEffect, useState } from "react";
import ModalUnidadeUnificada from "./components/ModalUnidadeUnificada";
import useDeleteUnidadeUnificada from "core/features/unidade-unificada/hooks/useDeleteUnidadeUnificada";

function UnidadesUnificadasListagemPage() {
  const [editId, setEditId] = useState<string | undefined>();
  const [modalOpen, setModalOpen] = useState(false);
  const { filtro, onChangeFiltro } = useFiltro();

  const { isLoading, isFetching, data, refetch } = useUnidadesUnificadas({
    page: filtro.page || 1,
    limit: filtro.limit,
    search: filtro.search,
  });

  const { mutate: deletarUnidadeUnificada, isLoading: isLoadingDeletar } =
    useDeleteUnidadeUnificada();

  const columns = useUnidadesUnificadasColumns();

  useBreadcrumb([
    { name: "Cadastros", url: "/cadastros" },
    { name: "Unidades unificadas", url: "/cadastros/unidades-unificadas" },
  ]);

  const onClose = () => {
    setModalOpen(false);
  };

  useEffect(() => {
    if (editId) {
      setModalOpen(true);
    }
  }, [editId]);

  useEffect(() => {
    if (!modalOpen) {
      setEditId(undefined);
    }
  }, [modalOpen]);

  const _isLoading = isLoading || isLoadingDeletar || isFetching;

  return (
    <Container>
      <ModalUnidadeUnificada
        visible={modalOpen}
        onClose={onClose}
        onSaved={() => {
          showSuccess().then(() => {
            refetch();
            onClose();
          });
        }}
        editId={editId}
      />

      <PageHeader
        onClick={() => setModalOpen(true)}
        title="Unidades unificadas"
        titleButton="Criar nova unificação"
      />

      <NewTable<UnidadeUnificadaResponse>
        loading={_isLoading}
        columns={columns}
        dataSource={data?.items ?? []}
        customPagination={{
          currentPage: data?.meta.currentPage ?? 0,
          totalItems: data?.meta.totalItems ?? 0,
          itemsPerPage: data?.meta.itemsPerPage ?? 0,
          onChangePage: (p) => onChangeFiltro("page", p),
        }}
        actions={[
          {
            title: "Editar",
            onClick: (v) => {
              setEditId(v.id);
            },
          },
          {
            title: "Excluir",
            onClick: async (v) => {
              const { isConfirmed } = await showConfirm();

              if (isConfirmed) {
                deletarUnidadeUnificada(v.id, {
                  onSuccess: () => refetch(),
                });
              }
            },
          },
        ]}
      />
    </Container>
  );
}

export default UnidadesUnificadasListagemPage;
